var FitToScrollerSupport        = require("enyo-ui/FitToScrollerSupport"),
    IconButton                  = require("app/ui/IconButton"),
    Popup                       = require("app/ui/Popup"),
    Scroller                    = require("enyo-ui/Scroller"),
    ScrollerDecoratorScrollbars = require("app/ui/ScrollerDecoratorScrollbars"),
    icons                       = require("app/theme/icons"),
    kind                        = require("enyo/kind");

require("app/ui/ScrollerPopup.less");
require("app/theme/IconButton--close.less");
require("app/theme/ScrollerDecoratorScrollbars--popup.less");

module.exports = kind(/** @lends  app.ui.ScrollerPopup.prototype */ {

    /**
     * @private
     */
    name: "app.ui.ScrollerPopup",

    /**
     * @private
     */
    kind: Popup,

    /**
     * @private
     */
    classes: "app-ui-scroller-popup",

    /**
     * @public
     */
    centerContent: true,

    /**
     * @public
     */
    scrollerDecoratorTheme: "popup",

    /**
     * @private
     */
    windowComponents: [{
        name:               "scrollerDecorator",
        kind:               ScrollerDecoratorScrollbars,
        classes:            "app-ui-scroller-popup__scroller-decorator",
        scrollerPath:       ".owner.$.scroller",
        fadeChromeOnScroll: true,
        components:         [{
            name:           "scroller",
            kind:           Scroller,
            classes:        "app-ui-scroller-popup__scroller",
            vertical:       true,
            horizontal:     false,
            scrollChaining: false,
            components:     [{
                name:         "client",
                mixins:       [FitToScrollerSupport],
                classes:      "app-ui-scroller-popup__client",
                scrollerPath: ".owner.$.scroller"
            }]
        }]
    }, {
        name:    "closeButton",
        kind:    IconButton,
        classes: "app-ui-scroller-popup__close-button",
        icon:    icons["app.ui.ScrollerPopup.closeButton"],
        theme:   "close",
        ontap:   "onCloseButtonTap"
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".scrollerDecoratorTheme",
        to:   ".$.scrollerDecorator.theme"
    }],

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.centerContentChanged();
        };
    }),

    /**
     * @private
     */
    centerContentChanged: function() {
        var client = this.$.client;

        if (this.centerContent) {
            !client.hasClass("center-content") && client.addClass("center-content");
        }
        else {
            while (client.hasClass("center-content")) {
                client.removeClass("center-content");
            }
        }
    },

    /**
     * Set theme classes based on current theme.
     *
     * @param  {string}  previousTheme  The previous theme
     * @private
     */
    themeChanged: function(previousTheme) {
        var currentTheme = this.get("theme"),
            baseClass    = "app-ui-scroller-popup",
            $client      = this.$.client;

        if (previousTheme && previousTheme !== currentTheme) {
            this.removeClass(baseClass + "--" + previousTheme);
            $client.removeClass(baseClass + "__client--" + previousTheme);
        }

        if (currentTheme && currentTheme !== previousTheme) {
            this.addClass(baseClass + "--" + currentTheme);
            $client.addClass(baseClass + "__client--" + currentTheme);
        }
    }

});
